import { Image, handleEnterKey } from '@iheartjane/reefer';

import styles from './carouselItem.module.css';

export type CarouselItemProps = {
  activeIndex: number;
  fallbackSrc?: string;
  imageAlt: string;
  imageSrc: string;
  index?: number;
  onClick: () => void;
  srcSet?: string;
  url?: string | null;
  variant: string;
};

export const CarouselItem = ({
  activeIndex,
  fallbackSrc,
  imageAlt,
  imageSrc,
  index = 0,
  onClick,
  srcSet,
  url,
}: CarouselItemProps) => {
  const imageObjectFit = 'cover';
  const imageBorderRadius = 'none';
  const isActive = activeIndex === index;
  const isPriority = isActive || Math.abs(activeIndex - index) <= 1;

  return (
    /** @todo use elements with appropriate role */
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={styles['innerCarouselItem']}
      data-testid="carousel-item"
      draggable={false}
      onClick={onClick}
      onKeyUp={(event) => handleEnterKey(event, onClick)}
    >
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles['innerCarouselImg']}
        >
          <Image
            src={imageSrc}
            srcSet={srcSet}
            altText={imageAlt}
            objectFit={imageObjectFit}
            height="100%"
            borderRadius={imageBorderRadius}
            fallbackSrc={fallbackSrc}
            loading={isPriority ? 'eager' : 'lazy'}
          />
        </a>
      ) : (
        <Image
          src={imageSrc}
          srcSet={srcSet}
          altText={imageAlt}
          objectFit={imageObjectFit}
          height="100%"
          borderRadius={imageBorderRadius}
          fallbackSrc={fallbackSrc}
          className={styles['innerCarouselImg']}
          loading={isPriority ? 'eager' : 'lazy'}
        />
      )}
    </div>
  );
};
